import { createSlice } from "@reduxjs/toolkit";

export interface AuthenticationState {
  userRole: string;
  email: string;
  sub: string;
}

const initialState: AuthenticationState = {
  userRole: "",
  email: "",
  sub: "",
};

export const AuthenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    setUserEmail: (state, action) => {
      state.email = action.payload;
    },
    setUserSub: (state, action) => {
      state.sub = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserRole, setUserEmail, setUserSub } = AuthenticationSlice.actions;

export const selectUserRole = (state: any) => state.authentication.userRole;
export const selectUserEmail = (state: any) => state.authentication.email;
export const selectUserSub = (state: any) => state.authentication.sub;


export default AuthenticationSlice.reducer;
